import React from 'react';
import { Link } from 'react-router-dom';

const Venus = () => {
	return (
	<>
<p><Link to="/">Home</Link></p>
<h1>Venus</h1>

<img alt="Planet Venus Mythology" src="https://upload.wikimedia.org/wikipedia/commons/0/08/Venus_from_Mariner_10.jpg" style={{"width":"200px","margin-top":"10px"}}/>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Aphrodite" >Aphrodite - Greek</a></p>
<p className="godDescription">Associated with love, beauty, pleasure, passion and procreation. Aphrodite's major symbols include myrtles, roses, doves, sparrows, and swans.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Astarte" >Astarte - Canaanite / Phoenician</a></p>
<p className="godDescription">War, sexuality, royal power, healing, hunting. Her symbol was the lion and she was also often associated with the horse and by extension chariots. The dove might be a symbol of her as well, as evidenced by some bronze age cylinder seals.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Frigg" >Frigg - Norse</a></p>
<p className="godDescription">Associated with marriage, prophecy, clairvoyance and motherhood</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Inanna" >Inanna - Mesopotamia</a></p>
<p className="godDescription">Love, beauty, sex, war, justice and political power. The lion and the eight-pointed star. </p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Lucifer" >Lucifer - Roman</a></p>
<p className="godDescription">Lightbringer</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Quetzalcoatl" >Quetzalcoatl - Aztec</a></p>
<p className="godDescription">Related to gods of the wind, of the planet Venus, of the dawn, of merchants and of arts, crafts and knowledge. He was also the patron god of the Aztec priesthood, of learning and knowledge.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Zorya" >Zorya - Slavic</a></p>
<p className="godDescription">Goddess of the dawn</p>

<hr />
<p><a href="https://en.wikipedia.org/wiki/Category:Temples_of_Venus">Temples of Venus</a></p>

			<p>Common associations:</p>
			<p>Day: Friday</p>
	</>
	)
}

export default Venus;